import React, { useEffect, useState } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, Spinner, FormFeedback, FormGroup, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import OSelect from '../../../../Components/OElements/OSelect';
import OHr from '../../../../Components/OElements/OHr';
import { DatePickerInput, DatesProvider } from '@mantine/dates';
import { addNewConsumptionSource, updateConsumptionSource } from '../../../../slices/consumptionSource/thunk';
import { getPowerGenerationRegisterStatusCode } from '../../../../slices/powerGenerationRegisterStatus/thunk';
import { getEstablishmentList, getEstablishmentTypeList, getFeedingBargesList, getFuelTankList, getFuelTankListByEstablishment, getFuelTypeList, getFuelTypeUnitMeasurementList, getPowerGenerationRegisterStatusList, getConsumptionSourceList, getPowerGenerationStatusList, getPowerGenerationTypeList, getPropertyTypeList, getConsumptionSourceTypeList } from '../../../../helpers/establishment/backend_helper';

import { setRequireCloseModal } from '../../../../slices/consumptionSource/reducer';
import { sendNewEmailMessage, getEstablishment, getFeedingBarges, getFileTypeByCode, getUserByRoles, uploadFile, addNewNotification, addNewBulkNotification } from '../../../../slices/thunks';
import { useUser } from '../../../../Components/Hooks/useUserHooks';
import { sub } from 'date-fns';
import OInput from '../../../../Components/OElements/OInput';

// import sendMessage from '../../../../Components/Hooks/useNotificationHooks';

const ConsumptionSourceForm = ({ dataConsumptionSource, isEdit, handleToggleModal, isOpen, edit_environment = false }) => {
	const dispatch = useDispatch();
	const { user } = useUser();

	const [activeTab, setActiveTab] = useState('1');
	const [isLoading, setIsLoading] = useState(false);

	const toggleTab = (tab) => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	const selectorConsumptionSource = createSelector(
		state => state.ConsumptionSource,
		result => ({
			isAdding: result.isAdding,
			isUpdating: result.isUpdating,
			requireCloseModal: result.requireCloseModal,
		})
	);
	const { isAdding, isUpdating, requireCloseModal } = useSelector(selectorConsumptionSource);


	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			// Información básica 
			name: dataConsumptionSource?.name || null,
			consumption_source_type_id: dataConsumptionSource?.consumption_source_type_id || null,
			fuel_type_id: dataConsumptionSource?.fuel_type_id || null,
			establishment_ids: dataConsumptionSource?.establishment_ids || [],
			description: dataConsumptionSource?.description || null,

			with_authorization: dataConsumptionSource?.with_authorization || false,
			emission_calculation: dataConsumptionSource?.emission_calculation || false,
		},
		validationSchema: Yup.object({
			// Información básica
			name: Yup.string().required('Campo requerido'),
			consumption_source_type_id: Yup.string().required('Campo requerido'),
			fuel_type_id: Yup.string().required('Campo requerido'),
			establishment_ids: Yup
				.array()
				.of(Yup.string()),
			description: Yup.string().nullable(),

			with_authorization: Yup.bool().nullable(),
			emission_calculation: Yup.bool().nullable(),

		}),
		onSubmit: async (values) => {
			setIsLoading(true);
			const consumption_source = { ...values, };

			if (isEdit) {
				dispatch(updateConsumptionSource({ ...consumption_source, _id: dataConsumptionSource._id }));
			} else {

				console.log(consumption_source)
				dispatch(addNewConsumptionSource(consumption_source));
			}

			setIsLoading(false);
			dispatch(setRequireCloseModal(false));
			handleToggleModal();

		},

	});


 
	return (
		<Form onSubmit={e => {
			e.preventDefault();
			if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
			validation.handleSubmit();
			return false;
		}}>
			<div className='modal-content border-0 mt-3'>
				<Nav className='nav-tabs nav-tabs-custom nav-success p-2 pb-0 bg-light'>
					<NavItem>
						<NavLink
							href='#'
							className={classnames({ active: activeTab === '1' })}
							onClick={() => toggleTab('1')}
						>
							Información General
						</NavLink>
					</NavItem>
				</Nav>
			</div>
			<ModalBody className='modal-body'>
				<TabContent activeTab={activeTab}>

					<TabPane tabId='1'>
						<Row className='g-3'>
							<Col lg={3}>
								<OInput
									name='name'
									label='Nombre'
									type='text'
									validation={validation}
									disabled={edit_environment}
									isRequired={true}
									classNameLabel='form-label'
									classNameInput='form-control'
								/>
							</Col>
							<Col lg={3}>
								<OSelect
									key='consumption_source_type_id'
									label='Tipo de Fuente de Consumo'
									id='consumption_source_type_id'
									name='consumption_source_type_id'
									isRequired={true}
									value={dataConsumptionSource?.consumption_source_type_id || ''}
									onChange={validation.handleChange}
									requestApi={() => getConsumptionSourceTypeList({})}
									validation={validation}
								/>
							</Col>
							<Col lg={3}>
								<OSelect
									key='fuel_type_id'
									label='Tipo Combustible'
									id='fuel_type_id'
									name='fuel_type_id'
									disabled={edit_environment}
									isRequired={true}
									value={dataConsumptionSource?.fuel_type_id || ''}
									onChange={validation.handleChange}
									requestApi={() => getFuelTypeList({})}
									validation={validation}
								/>
							</Col>
							<Col lg={3}>
								<OSelect
									key='establishment_ids'
									label='Establecimientos Responsables'
									id='establishment_ids'
									name='establishment_ids'
									value={dataConsumptionSource?.establishment_ids || ''}
									onChange={validation.handleChange}
									requestApi={() => getEstablishmentList({})}
									validation={validation}
									isMulti={true}
								/>
							</Col>
							<Col lg={3}>
								<div className="form-check form-switch form-switch-md d-flex flex-column p-0" dir="ltr">
									<label className="form-check-label" htmlFor="with_authorization">
										¿Requiere Autorización?
									</label>
									<input
										type="checkbox"
										className="form-check-input"
										style={{ marginLeft: '10px' }}
										id="with_authorization"
										name="with_authorization"
										checked={validation.values.with_authorization}
										onChange={() => validation.setFieldValue('with_authorization', !validation.values.with_authorization)}
									/>
								</div>
							</Col>

							<Col lg={3}>
								<div className="form-check form-switch form-switch-md d-flex flex-column p-0" dir="ltr">
									<label className="form-check-label" htmlFor="emission_calculation">
										¿Considerar en el cálculo de emisiones?
									</label>
									<input
										type="checkbox"
										className="form-check-input"
										style={{ marginLeft: '10px' }}
										id="emission_calculation"
										name="emission_calculation"
										checked={validation.values.emission_calculation}
										onChange={() => validation.setFieldValue('emission_calculation', !validation.values.emission_calculation)}
									/>
								</div>
							</Col>

							<Col lg={12}>
								<OInput
									name='description'
									label='Descripción'
									type='textarea'
									placeholder='Ingrese la descripción'
									validation={validation}
									classNameLabel='form-label'
									classNameInput='form-control'
								/>
							</Col>
						</Row>
					</TabPane>

				</TabContent>
			</ModalBody>


			<div className='modal-footer'>
				<Button type='button' onClick={handleToggleModal} className='btn-danger btn-label'>
					<i className="icon-x label-icon"></i>Cancelar
				</Button>
				<button type='submit' className='btn btn-label btn-primary' id='add-btn' disabled={isLoading}>
					{isLoading ? (<i className='label-icon'><Spinner size='sm' /></i>) : (<i className='ri-save-3-line label-icon'></i>)}
					{isEdit ? 'Editar' : 'Crear'} Fuente de Consumo
				</button>
			</div>
		</Form>
	);
};

export default ConsumptionSourceForm;
